import React from 'react';
import { Card, CardContent } from '../ui/card';
import { CheckCircle, Users, Clock, FileText, Shield, BarChart } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      title: 'Checklisten-Management',
      description: 'Erstellen, verwalten und abarbeiten Sie individuelle oder vordefinierte Checklisten.',
      icon: <CheckCircle className="w-6 h-6" />
    },
    {
      title: 'Responsible Gaming',
      description: 'Geführte Prozesse zur Identifikation, Dokumentation und Verfolgung problematischen Spielverhaltens.',
      icon: <Shield className="w-6 h-6" />
    },
    {
      title: 'Erinnerungen & Fristen',
      description: 'Automatische Erinnerungen und Fristenverwaltung für wichtige Compliance-Aufgaben.',
      icon: <Clock className="w-6 h-6" />
    },
    {
      title: 'Reporting & Exporte',
      description: 'Umfangreiche Berichte und einfache Datenexporte für Auditoren und Behörden.',
      icon: <BarChart className="w-6 h-6" />
    },
    {
      title: 'Rollen & Rechte',
      description: 'Flexibles Nutzer- und Rollenmanagement mit anpassbaren Dashboards.',
      icon: <Users className="w-6 h-6" />
    },
    {
      title: 'DSGVO-konform',
      description: 'Höchste Standards bei Datenschutz und DSGVO-konformer Speicherung.',
      icon: <FileText className="w-6 h-6" />
    }
  ];

  return (
    <section id="features" className="py-16 bg-gray-100 relative overflow-hidden">
      {/* Decorative IDA (8) Background */}
      <div className="absolute top-10 right-10 opacity-5 pointer-events-none">
        <img
          src="/images/ida-8.webp"
          alt="IDA Decoration"
          className="w-96 h-96 object-contain"
          loading="lazy"
        />
      </div>
      <div className="absolute bottom-10 left-10 opacity-5 pointer-events-none">
        <img
          src="/images/ida-8.webp"
          alt="IDA Decoration"
          className="w-96 h-96 object-contain transform rotate-180"
          loading="lazy"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12">Was IDA macht</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="shadow-lg border-2 border-gray-200 bg-gradient-to-br from-white to-gray-50">
              <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-3 bg-gradient-to-br from-teal-100 to-teal-200 rounded-xl text-teal-800 shadow-md">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{feature.title}</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
